'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _containers = require('containers');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Configuration = function (_Component) {
  (0, _inherits3.default)(Configuration, _Component);

  function Configuration(props) {
    (0, _classCallCheck3.default)(this, Configuration);
    return (0, _possibleConstructorReturn3.default)(this, (Configuration.__proto__ || (0, _getPrototypeOf2.default)(Configuration)).call(this, props));
  }

  (0, _createClass3.default)(Configuration, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var STATUS = this.props.STATUS;

      if (!__SERVER__ && this.props.genericSettingsStatus === STATUS.UNRETRIEVED) {
        this.props.getGenericSettings(this.props.codedToken);
        this.props.getStorageOptions(this.props.codedToken);
        this.props.getConfiguration(this.props.codedToken);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_styles2.default.root) },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Configuration' }),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.container },
          _react2.default.createElement(_containers.ActionsOnProceed, null)
        )
      );
    }
  }]);
  return Configuration;
}(_react.Component);

exports.default = Configuration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Configuration/Configuration.jsx
// module id = 1451
// module chunks = 0